export const LOCALE_MAP = {
  "Arabic (Bahrain)": "ar-BH",
  "Arabic (Egypt)": "ar-EG",
  "Arabic (Jordan)": "ar-JO",
  "Arabic (Kuwait)": "ar-KW",
  "Arabic (Morocco)": "ar-MA",
  "Arabic (Oman)": "ar-OM",
  "Arabic (Qatar)": "ar-QA",
  "Arabic (Saudi Arabia)": "ar-SA",
  "Arabic (United Arab Emirates)": "ar-AE",
  "Basque (Spain)": "eu-ES",
  "Catalan (Spain)": "ca-ES",
  "Chinese (China)": "zh-CN",
  "Croatian (Croatia)": "hr-HR",
  "Czech (Czech Republic)": "cs-CZ",
  "Danish (Denmark)": "da-DK",
  "Dutch (Belgium)": "nl-BE",
  "Dutch (Netherlands)": "nl-NL",
  "English (Australia)": "en-AU",
  "English (Austria)": "en-AT",
  "English (Bahrain)": "en-BH",
  "English (Belgium)": "en-BE",
  "English (Canada)": "en-CA",
  "English (China)": "en-CN",
  "English (Czech Republic)": "en-CZ",
  "English (Egypt)": "en-EG",
  "English (Finland)": "en-FI",
  "English (Germany)": "en-DE",
  "English (India)": "en-IN",
  "English (Ireland)": "en-IE",
  "English (Japan)": "en-JP",
  "English (Jordan)": "en-JO",
  "English (Kuwait)": "en-KW",
  "English (Malaysia)": "en-MY",
  "English (Mexico)": "en-MX",
  "English (Morocco)": "en-MA",
  "English (Netherlands)": "en-NL",
  "English (Norway)": "en-NO",
  "English (Oman)": "en-OM",
  "English (Philippines)": "en-PH",
  "English (Portugal)": "en-PT",
  "English (Qatar)": "en-QA",
  "English (Saudi Arabia)": "en-SA",
  "English (Singapore)": "en-SG",
  "English (South Korea)": "en-KR",
  "English (Spain)": "en-ES",
  "English (Sweden)": "en-SE",
  "English (Switzerland)": "en-CH",
  "English (Thailand)": "en-TH",
  "English (United Arab Emirates)": "en-AE",
  "English (United Kingdom)": "en-GB",
  "English (United States)": "en-US",
  "Finnish (Finland)": "fi-FI",
  "French (Belgium)": "fr-BE",
  "French (Canada)": "fr-CA",
  "French (France)": "fr-FR",
  "French (Morocco)": "fr-MA",
  "French (Switzerland)": "fr-CH",
  "Galician (Spain)": "gl-ES",
  "German (Austria)": "de-AT",
  "German (Germany)": "de-DE",
  "German (Switzerland)": "de-CH",
  "Hebrew (Israel)": "he-IL",
  "Hungarian (Hungary)": "hu-HU",
  "Italian (Italy)": "it-IT",
  "Italian (Switzerland)": "it-CH",
  "Japanese (Japan)": "ja-JP",
  "Korean (South Korea)": "ko-KR",
  "Lithuanian (Lithuania)": "lt-LT",
  "Malay (Malaysia)": "ms-MY",
  "Norwegian (Norway)": "nb-NO",
  "Polish (Poland)": "pl-PL",
  "Portuguese (Portugal)": "pt-PT",
  "Romanian (Romania)": "ro-RO",
  "Russian (Russia)": "ru-RU",
  "Serbian (Serbia)": "sr-RS",
  "Slovak (Slovakia)": "sk-SK",
  "Slovenian (Slovenia)": "sl-SI",
  "Spanish (Chile)": "es-CL",
  "Spanish (Colombia)": "es-CO",
  "Spanish (Mexico)": "es-MX",
  "Spanish (Spain)": "es-ES",
  "Spanish (United States)": "es-US",
  "Swedish (Finland)": "sv-FI",
  "Swedish (Sweden)": "sv-SE",
  "Thai (Thailand)": "th-TH",
  "Ukrainian (Ukraine)": "uk-UA",
} as const;
